import React, { lazy, Suspense } from 'react'
import { Route, Switch } from 'react-router'

const Index = lazy(() => import('pages/platform/shop/Index'))
const SeeMore = lazy(() => import('pages/platform/shop/SeeMore'))


const ActivityRoute = ({ match }) => {
  const rootUrl = match.url
  return (
    <Suspense fallback={null}>
      <Switch>
        <Route exact path={`${rootUrl}/index`} component={(Index)} />
        <Route exact path={`${rootUrl}/seeMore`} component={(SeeMore)} />
      </Switch>
    </Suspense>
  )
}
export default ActivityRoute
